// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectTradeMessage } from './DirectTradeMessage';
import { Message } from './Message';
export class DirectModifyTradeMessage extends DirectTradeMessage {
    constructor() {
        super();
        this.Code = Message.CODE_MODIFY_TRADE_MESSAGE;
    }
}
